export default __webpack_public_path__ + "static/media/crosshair-fill.580033d7.svg";